export const DEFAULT_SEGMENTATION = {
    maxWords: 6,
    preferredWords: 4,
    maxChars: 42,
    maxLines: 2,
    pauseThresholdMs: 500,
    breakOnSentencePunctuation: true,
};
//# sourceMappingURL=types.js.map